import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Vue.config.productionTip = false;

import '@/assets/css/main.css'

Vue.prototype.$http = axios;
Vue.prototype.axios = axios;

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Sentry.init({
//   dsn: 'https://68362d954eb34063bc6c4b828e1065c2@sentry.io/1522313',
//   integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
